<template>
  <div>
    <Loading v-if="loading" />
    <div v-if="!loading" class="edit-form py-3">
      <v-layout column align-center>
        <creds-card
          :credentials="credentials"
          :read_only="read_only"
          :creds_creation="creds_creation"
          @update_credentials="
            update_credentials($event.credentials, $event.change_credentials)
          "
          @create_credentials="create_credentials($event.credentials)"
        >
        </creds-card>
      </v-layout>
    </div>
  </div>
</template>

<script>
import adminApi from "@/api/admin";
import CredsCard from "@/components/credentials/CredsCard.vue";
import { mapGetters } from "vuex";
import Loading from "@/components/shared/Loading.vue";

export default {
  components: {
    CredsCard,
    Loading,
  },
  mounted() {
    this.get_credentials();
  },
  data() {
    return {
      loading: false,
      credentials: null,
      read_only: false,
      creds_creation: false,
    };
  },
  watch: {
    $route() {
      this.get_credentials();
    },
  },
  computed: {
    ...mapGetters(["user_details", "account_details"]),
  },
  methods: {
    update_read_only() {
      this.read_only = !this.read_only;
    },

    get_credentials() {
      this.loading = true;
      const creds_id = this.$route.params.creds_id;
      if (creds_id) {
        return adminApi
          .get_credentials(this.user_details.account_id, creds_id)
          .then((response) => {
            this.loading = false;
            this.credentials = response.data;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.credentials = {
          registered_credentials: {},
        };
        this.read_only = false;
        this.creds_creation = true;
        this.loading = false;
      }
    },

    update_credentials(credentials, change_credentials) {
      this.loading = true;
      let updated = {};

      if (
        credentials.registered_credentials.description ||
        credentials.registered_credentials.description === ""
      ) {
        updated.description = credentials.registered_credentials.description;
      }

      if (change_credentials) {
        updated.credentials = credentials.registered_credentials.credentials;
      }

      const account_id = this.user_details.account_id;
      const creds_id = this.$route.params.creds_id;
      return adminApi
        .patch_credentials(account_id, creds_id, updated)
        .then(() => {
          this.$router.push({
            name: "creds-list",
            params: {
              account_id: account_id,
            },
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },

    create_credentials(credentials) {
      this.loading = true;
      const new_credentials = {
        description: credentials.registered_credentials.description,
        credentials: credentials.registered_credentials.credentials,
      };

      const account_id = this.user_details.account_id;
      const creds_id = credentials.registered_credentials.credentials_id;
      return adminApi
        .put_credentials(account_id, creds_id, new_credentials)
        .then(() => {
          this.$router.push({
            name: "creds-list",
            params: {
              account_id: account_id,
            },
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
